import { PiDogFill } from 'react-icons/pi';
import { IoLogoOctocat } from 'react-icons/io5';
import { GiParrotHead } from 'react-icons/gi';
import { GiTigerHead } from 'react-icons/gi';

import { GiKoala } from 'react-icons/gi';

import { RiMotorbikeFill } from 'react-icons/ri';
import { FaTruckMonster } from 'react-icons/fa6';
import { GiSteamLocomotive } from 'react-icons/gi';
import { GoRocket } from 'react-icons/go';
import { GiMiniSubmarine } from 'react-icons/gi';

import { RiRestartLine } from 'react-icons/ri';

import { useEffect, useState } from 'react';
import { getAllFilteredUsers } from '../../firebase-functions/database';

import { IoTriangleSharp } from 'react-icons/io5';
import { FaSquare } from 'react-icons/fa';
import { FaCircle } from 'react-icons/fa';
import { FaPlusCircle } from 'react-icons/fa';
import { PiDivideFill } from 'react-icons/pi';
import { FaMinusCircle } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';

import { TbMedicalCrossFilled } from 'react-icons/tb';
import { AiFillHeart } from 'react-icons/ai';
import { GoStarFill } from 'react-icons/go';
import { AiFillMoon } from 'react-icons/ai';
import { BsDropletFill } from 'react-icons/bs';
import { FaShieldAlt } from 'react-icons/fa';
import { AvatarView } from './StudentAccount/AvatarView';

export const UserBox = (props) => {
  const step = props.step;
  const setStep = props.setStep;
  const pet = props.pet;
  const setPet = props.setPet;
  // const [car, setCar] = useState();
  // const [color, setColor] = useState();
  const [userNames, setUserNames] = useState([]);

  const userNameIcons = [
    <IoTriangleSharp />,
    <FaSquare />,
    <FaCircle />,
    <FaPlusCircle />,
    <PiDivideFill />,
    <FaMinusCircle />,
    <ImCross />,
    <TbMedicalCrossFilled />,
    <AiFillHeart />,
    <GoStarFill />,
    <BsDropletFill />,
    <FaShieldAlt />,
  ];
  const handleClick = (category, val) => {
    setStep(step + 1);

    if (category === 'pet') {
      setPet(val);
    }
  };

  useEffect(() => {
    if (step === 2) {
      getAllFilteredUsers(pet).then((res) => {
        if (!res.success) {
          setUserNames([]);
          return;
        }
        setUserNames(res.message);
      });
    }
  }, [step]);

  return (
    <div
      className='user-box-container'
      style={{
        backgroundImage:
          'https://w0.peakpx.com/wallpaper/1005/288/HD-wallpaper-harry-potter-film.jpg',
      }}>
      {step === 1 && (
        <div className='username-icon-box-container'>
          <h3>Choose Your Pet</h3>

          <div className='username-icon-box'>
            <PiDogFill
              onClick={() => {
                handleClick('pet', 1);
              }}
            />
            {/* <IoLogoOctocat
              onClick={() => {
                handleClick("pet", 2);
              }}
            />
            <GiParrotHead
              onClick={() => {
                handleClick("pet", 3);
              }}
            /> */}
            <GiTigerHead
              onClick={() => {
                handleClick('pet', 4);
              }}
            />
            {/* <GiKoala
              onClick={() => {
                handleClick("pet", 5);
              }}
            /> */}
          </div>
        </div>
      )}

      {step === 2 && (
        <div className='username-icon-box-container'>
          <h3>Choose Your Account</h3>
          {userNames && userNames?.length > 0 && (
            <div className='username-icons'>
              {userNames.map((us, index) => (
                <div
                  className={
                    props?.email && props.email === us.email
                      ? 'username-icon-user-box username-icon-user-box-active'
                      : 'username-icon-user-box'
                  }
                  key={us?.email || ''}
                  onClick={() => {
                    props.setEmail(us.email);
                    setStep(3);
                    props.setUser(us);
                  }}>
                  <AvatarView
                    avatarInfo={us.avatar}
                    isLogin={true}
                    isMobile={window.innerWidth < 600}
                  />

                  <p className='username-icon-name'>{us.name}</p>
                </div>
              ))}
            </div>
          )}
          {step === 2 && (
            <button
              className='username-icon-btn-restart'
              onClick={(e) => {
                e.preventDefault();
                setStep(1);
              }}>
              Go back <RiRestartLine />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
